import { Cell, HFlow, InfoLabel, Tag, useStyles } from 'bold-ui'
import { turquoise } from 'bold-ui/lib/styles/colors'
import { CondicaoMaternalDbEnum, SexoEnum } from 'graphql/types.generated'
import { CSSProperties, Fragment } from 'react'

import { CondicoesFormModel, isBcg } from '../model'
import { shouldShowCondicaoMaternal, shouldShowCondicaoSimples } from '../utils-vacinacao'

interface CondicoesVacinacaoDoseProps {
  sexoIdentidadeGenero: SexoEnum
  registradoAtendimento: boolean
  imunobiologicoId: string
  condicoesVacinacao: CondicoesFormModel
  condicaoMaternal: CondicaoMaternalDbEnum
  isViajante: boolean
  isComunicanteHanseniase: boolean
}

export const CondicoesVacinacaoDose = (props: CondicoesVacinacaoDoseProps) => {
  const {
    sexoIdentidadeGenero,
    registradoAtendimento,
    imunobiologicoId,
    condicoesVacinacao,
    condicaoMaternal,
    isViajante,
    isComunicanteHanseniase,
  } = props

  const { classes } = useStyles(createStyles)

  const { condicao, viajante, comunicanteHanseniase } = condicoesVacinacao

  const hasSexoFemininoIndeterminado = sexoIdentidadeGenero === 'FEMININO' || sexoIdentidadeGenero === 'INDETERMINADO'

  const hasCondicaoMaternal = shouldShowCondicaoSimples(registradoAtendimento, !!condicao, !!condicaoMaternal)

  const hasCondicaoViajanteHanseniase = shouldShowCondicaoSimples(
    registradoAtendimento,
    viajante || (comunicanteHanseniase && isBcg(imunobiologicoId)),
    isViajante || (isComunicanteHanseniase && isBcg(imunobiologicoId))
  )

  const hasCondicoesVacinacaoMaternalOutros = hasCondicaoMaternal || hasCondicaoViajanteHanseniase

  const renderMaternalTags = () => (
    <HFlow hSpacing={0.5}>
      {shouldShowCondicaoMaternal(
        registradoAtendimento,
        condicao,
        condicaoMaternal,
        CondicaoMaternalDbEnum.PUERPERA
      ) && <Tag style={classes.condicaoTag}>Puérpera</Tag>}
      {shouldShowCondicaoMaternal(
        registradoAtendimento,
        condicao,
        condicaoMaternal,
        CondicaoMaternalDbEnum.GESTANTE
      ) && <Tag style={classes.condicaoTag}>Gestante</Tag>}
      {shouldShowCondicaoMaternal(
        registradoAtendimento,
        condicao,
        condicaoMaternal,
        CondicaoMaternalDbEnum.NENHUMA
      ) && <Tag style={classes.condicaoTag}>Nenhuma</Tag>}
    </HFlow>
  )

  const renderOutrosTags = () => (
    <HFlow hSpacing={0.5}>
      {shouldShowCondicaoSimples(registradoAtendimento, viajante, isViajante) && (
        <Tag style={classes.condicaoTag}>Viajante</Tag>
      )}
      {shouldShowCondicaoSimples(registradoAtendimento, comunicanteHanseniase, isComunicanteHanseniase) &&
        isBcg(imunobiologicoId) && <Tag style={classes.condicaoTag}>Comunicante de hanseníase</Tag>}
    </HFlow>
  )

  return (
    <Fragment>
      {hasSexoFemininoIndeterminado
        ? hasCondicoesVacinacaoMaternalOutros && (
            <Cell size={12}>
              <InfoLabel title='Condições'>
                {hasCondicaoMaternal && <InfoLabel title='Maternal'>{renderMaternalTags()}</InfoLabel>}
                {hasCondicaoViajanteHanseniase && <InfoLabel title='Outros'>{renderOutrosTags()}</InfoLabel>}
              </InfoLabel>
            </Cell>
          )
        : hasCondicaoViajanteHanseniase && (
            <Cell size={12}>
              <InfoLabel title='Condições'>{renderOutrosTags()}</InfoLabel>
            </Cell>
          )}
    </Fragment>
  )
}

const createStyles = () => ({
  condicaoTag: {
    backgroundColor: turquoise.c40,
    color: turquoise.c100,
  } as CSSProperties,
})
